var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.text,"placement":"bottom-start","disabled":!_vm.tooltip}},[_c('div',{ref:"tooltip-overflow",class:[{ 'overflow-active': _vm.tooltip }, 'overflow'],style:(_vm.dynamicWidth),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }